import { render, staticRenderFns } from "./UserId.vue?vue&type=template&id=27f02085&scoped=true&"
import script from "./UserId.vue?vue&type=script&lang=js&"
export * from "./UserId.vue?vue&type=script&lang=js&"
import style0 from "./UserId.vue?vue&type=style&index=0&id=27f02085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f02085",
  null
  
)

export default component.exports